<template>
  <div class="select-data-source">
    <div>
      <div>
        <div class="select-data-source__select-data-source-area">
          <div>Select Data Source</div>
        </div>
        <div class="select-data-source__icons">
          <template v-for="dataSource in availableDatasources">
            <div :key="dataSource.id">
              <div>
                <img
                  class="select-data-source__icon-def select-data-source__data-icon select-data-source__data-icon--def"
                  :id="`datasource-id-${dataSource.id}`"
                  :src="value === dataSource.id ? dataSource.img.selected : dataSource.img.default"
                  @click="() => emit(dataSource.id)"
                />
              </div>
              <div class="select-data-source__title">{{ dataSource.title }}</div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div
      v-if="attachFileEnabled"
      class="select-data-source__atach-a-file"
    >
      <div class="select-data-source__or-bar">
        <hr class="select-data-source__border-bar" />
        <!-- <span class="select-data-source__border-bar"></span> -->
        <span>OR</span>
        <hr class="select-data-source__border-bar" />
      </div>
      <div class="select-data-source__attach-button-area">
        <action-button
          @click.native="onFile"
          :dark="selectedOnFile"
          label="Attach A File"
          color="secondary"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { INTENTS } from '@/appLogic/targets/Constants'
  import AdstraDefaultImg from '@/assets/dataSources/adstra-Default.png'
  import AdstraSelectedImg from '@/assets/dataSources/adstra-Selected.png'
  import AmrldDefaultImg from '@/assets/dataSources/AMRLD-Default.png'
  import AmrldSelectedImg from '@/assets/dataSources/AMRLD-Selected.png'
  import MriDefaultImg from '@/assets/dataSources/MRI-Default.png'
  import MriSelectedImg from '@/assets/dataSources/MRI-Selected.png'
  import NielsenDefaultImg from '@/assets/dataSources/Ncs-Default.png'
  import NielsenSelectedImg from '@/assets/dataSources/Ncs-Selected.png'
  import ActionButton from '@/components/common/actionButton/ActionButton.vue'
  import EpsilonDefault from '@/assets/dataSources/Epsilon-Default.png'
  import EpsilonSelected from '@/assets/dataSources/Epsilon-Selected.png'
  import DCComicsDefault from '@/assets/dataSources/DC_Comics-Default.png'
  import DCComicsSelected from '@/assets/dataSources/DC_Comics-Selected.png'
  import CNNDefaultImg from '@/assets/dataSources/CNN-Default.png'
  import CNNSelectedImg from '@/assets/dataSources/CNN-Selected.png'
  import MosaicDefaultImg from '@/assets/dataSources/Mosaic-Default.png'
  import MosaicSelectedImg from '@/assets/dataSources/Mosaic-Selected.png'
  // import {PERMISSIONS_OLD} from '@/appLogic/permissions/Constants.js'

  export default {
    components: {
      ActionButton,
    },
    props: {
      value: {
        default: null,
      },
    },
    computed: {
      C360Datasources() {
        return this.$store.getters.getC360Datasources
      },
      nielsenDatasources() {
        return this.$store.getters.getNielsenDatasources
      },
      dataTypes() {
        return {
          NONE: null,
          ADSTRA: this.C360Datasources.ADSTRA,
          AMRLD: this.nielsenDatasources.AMRLD,
          MRI: this.nielsenDatasources.MRI,
          NCS: this.nielsenDatasources.NCS,
          FILE: this.nielsenDatasources.FILE,
          EPSILON: this.C360Datasources.EPSILON,
          DC_COMICS: this.C360Datasources.DC_COMICS,
          CNN: this.C360Datasources.CNN,
          MOSAIC: this.C360Datasources.MOSAIC,
        }
      },
      dataSourceImages() {
        return [
          {
            id: this.dataTypes.ADSTRA,
            title: 'Adstra',
            img: {
              // TODO: replace with new Adstra images
              default: AdstraDefaultImg,
              selected: AdstraSelectedImg,
            },
          },
          {
            id: this.dataTypes.AMRLD,
            title: 'AMRLD',
            img: {
              default: AmrldDefaultImg,
              selected: AmrldSelectedImg,
            },
          },
          {
            id: this.dataTypes.MRI,
            title: 'MRI',
            img: {
              default: MriDefaultImg,
              selected: MriSelectedImg,
            },
          },
          {
            id: this.dataTypes.NCS,
            title: 'NCS',
            img: {
              default: NielsenDefaultImg,
              selected: NielsenSelectedImg,
            },
          },
          {
            id: this.dataTypes.EPSILON,
            title: 'Epsilon',
            img: {
              default: EpsilonDefault,
              selected: EpsilonSelected,
            },
          },
          {
            id: this.dataTypes.DC_COMICS,
            title: 'DC Comics',
            img: {
              default: DCComicsDefault,
              selected: DCComicsSelected,
            },
          },
          {
            id: this.dataTypes.CNN,
            title: 'CNN',
            img: {
              default: CNNDefaultImg,
              selected: CNNSelectedImg,
            },
          },
          {
            id: this.dataTypes.MOSAIC,
            title: 'Mosaic',
            img: {
              default: MosaicDefaultImg,
              selected: MosaicSelectedImg,
            },
          },
        ]
      },
      availableDatasources() {
        if (this.$store.state.createTarget.intents.includes(INTENTS.Marketing.Name)) {
          return this.dataSourceImages.filter(d => [this.dataTypes.AMRLD].includes(d.id))
        }
        if (this.$store.state.createTarget.intents.includes(INTENTS.Research.Name)) {
          return this.dataSourceImages.filter(d => [this.dataTypes.AMRLD].includes(d.id))
        }
        if (this.$store.state.createTarget.intents.includes(INTENTS.Sales.Name)) {
          // Deprecated by AM-3571
          /*
        const salesDigitalSocialPermissions = [
          PERMISSIONS_OLD.AD_SALES_XANDR_KRUX,
          PERMISSIONS_OLD.AD_SALES_XANDR_LIVE_RAMP
        ]

        if (
          this.$store.state.auth.permissions.find(permission => salesDigitalSocialPermissions.includes(permission)) &&
          !this.$store.state.auth.permissions.includes(PERMISSIONS_OLD.AD_SALES_XANDR_SYMPHONY_CAE)
        ) {
          return DATA_SOURCE_IMAGES.filter(d => [DATA_TYPES.XANDR, DATA_TYPES.EPSILON].includes(d.id))
        }

        if (
          !this.$store.state.auth.permissions.find(permission => salesDigitalSocialPermissions.includes(permission)) &&
          this.$store.state.auth.permissions.includes(PERMISSIONS_OLD.AD_SALES_XANDR_SYMPHONY_CAE)
        ) {
          return DATA_SOURCE_IMAGES.filter(d => d.id !== DATA_TYPES.EPSILON)
        }
        */

          return this.dataSourceImages
        }
      },
      selectedOnFile() {
        return this.dataTypes.FILE === this.value
      },
      attachFileEnabled() {
        return (
          this.$store.state.createTarget.intents.includes(INTENTS.Sales.Name) &&
          this.$store.getters.hasPublishPermissions
        )
      },
    },
    methods: {
      onFile() {
        this.emit(this.dataTypes.FILE)
      },
      emit(v) {
        let sameValue = this.value === v
        if (sameValue) {
          // if the user selected the same value then it will return null
          this.$emit('input', this.dataTypes.NONE)
        } else {
          this.$emit('input', v)
        }
      },
    },
  }
  /**
   * flex center the horizontal or bar
   *
   */
</script>

<style lang="scss">
  .select-data-source {
    &__icons {
      display: flex;
      flex-shrink: 0;
      justify-content: center;
      margin-top: 20px;
    }

    &__select-data-source-area {
      display: flex;
      justify-content: center;
      flex-direction: column;
      margin: 0 auto;
      text-align: center;
    }

    &__title {
      display: flex;
      flex-shrink: 0;
      justify-content: center;
      font-weight: bold;
    }

    &__icon-def {
      margin-left: 20px;
      margin-right: 20px;
    }

    &__data-icon {
      width: 76px;
      height: 76px;
    }

    &__data-icon--def {
      cursor: pointer;
    }

    &__atach-a-file {
      width: 400px;
      margin: 0 auto;
    }

    &__or-bar {
      display: flex;
      justify-content: center;
      margin-top: 15px;
      margin-bottom: 15px;
    }

    &__attach-button-area {
      display: flex;
      justify-content: center;
      flex-direction: column;
      width: 200px;
      margin: 0 auto;
      text-align: center;

      &__text {
        margin-bottom: 15px;
      }
    }

    &__border-bar {
      width: 150px;
      display: inline-block;
      position: relative;
      top: 4px;
    }
  }
</style>



// WEBPACK FOOTER //
// SelectDataSource.vue?486db518